export enum WebFormTypes {
  MediaInvestment = 'media_investment',
  CompetitiveInvestment = 'competitive_investment',
  CompetitiveTVSOV = 'competitve_tv_share_of_voice',
}
